import { serverApi } from "./serverApi";
import { ErrorType } from "../types/sharedTypes";
import {
  FolderTestCaseTemplatesForSearch,
  TestCaseTemplate
} from "../types/testCaseTemplateTypes";

export const testCaseTemplateService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTestCaseTemplate: build.query<Array<TestCaseTemplate>, string>({
      query: () => ({
        url: "/test-case-template/all-template"
      })
    }),
    getAllFolderTemplates: build.query<Array<TestCaseTemplate>, number>({
      query: (folderId) => ({
        url: "/test-case-template/all-folder-templates",
        params: { folderId }
      })
    }),
    getAllFolderTemplatesForSearch: build.query<Array<FolderTestCaseTemplatesForSearch>, string>({
      query: () => ({
        url: "/test-case-template/all-folder-templates-for-search",
      })
    }),
    createTestCaseTemplate: build.mutation<number, TestCaseTemplate>({
      query: (testCaseTemplate) => ({
        url: "/test-case-template/template",
        method: "POST",
        body: testCaseTemplate
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    updateTestCaseTemplate: build.mutation<string, TestCaseTemplate>({
      query: (testCaseTemplate) => ({
        url: "/test-case-template/template",
        method: "PUT",
        body: testCaseTemplate
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    }),
    deleteTestCaseTemplate: build.mutation<string, number>({
      query: (testCaseTemplateId) => ({
        url: "/test-case-template/template",
        method: "DELETE",
        params: { id: testCaseTemplateId }
      }),
      transformErrorResponse: (baseQueryReturnValue, meta): ErrorType => {
        return {
          status: meta?.response?.status,
          statusText: meta?.response?.statusText,
          message: (baseQueryReturnValue.data as any)?.errorCode
        }
      }
    })
  })
});

export const {
  useGetAllTestCaseTemplateQuery,
  useLazyGetAllFolderTemplatesQuery,
  useLazyGetAllFolderTemplatesForSearchQuery,
  useGetAllFolderTemplatesForSearchQuery,
  useCreateTestCaseTemplateMutation,
  useUpdateTestCaseTemplateMutation,
  useDeleteTestCaseTemplateMutation
} = testCaseTemplateService;